/**
 * PATH: apps/qa/src/lib/api/inspections.ts
 * PURPOSE: QA Inspections CRUD API
 */

import { api, normaliseList } from './helpers'
import type { Inspection } from '@/types/qa'

export const inspectionApi = {
  getInspections: async (params?: {
    job_id?: string
    status?: string
    search?: string
    client?: string
    site?: string
    created_within_days?: number
    created_before?: string
    created_after?: string
    page?: number
    page_size?: number
  }): Promise<{ results: Inspection[]; count: number }> => {
    const response = await api().get('/qa/inspections/', { params })
    return normaliseList(response.data)
  },
  getInspection: async (id: string): Promise<Inspection> => {
    const response = await api().get(`/qa/inspections/${id}/`)
    return response.data
  },
  createInspection: async (data: Partial<Inspection>): Promise<Inspection> => {
    const response = await api().post('/qa/inspections/', data)
    return response.data
  },
  updateInspection: async (id: string, data: Partial<Inspection>): Promise<Inspection> => {
    const response = await api().patch(`/qa/inspections/${id}/`, data)
    return response.data
  },
  deleteInspection: async (id: string): Promise<void> => {
    await api().delete(`/qa/inspections/${id}/`)
  },
  publishInspection: async (id: string): Promise<Inspection> => {
    const response = await api().post(`/qa/inspections/${id}/publish/`)
    return response.data
  },
  submitInspection: async (id: string): Promise<Inspection> => {
    const response = await api().post(`/qa/inspections/${id}/submit/`)
    return response.data
  },
}
